import React from "react";
import TopNav from "../comps/Top";
import AboutContent from "../comps/AboutContent";
import styled from "styled-components";
import LText from "../comps/LogoText";

const About = () => {
  return (
    <Container>
      <TopNav />
      <AboutContent />
    </Container>
  );
};

export default About;

const Container = styled.div`
  min-height: calc(100vh - 150px);
  padding-bottom: 50px;
  background-color: #537bae;
  width: 100%;
  display: column;
`;
